import { AppState } from '../../../../state/AppState';
import { deleteDataAccelerationTask } from '../../../../actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { EntityActionNames, IEntityAction } from '../IEntityAction';
import { currentUserIsAdmin } from '../../../../utils/MixedContentHelpers';
import { IAccelerationTaskInfo } from '../../../../../ts/models/IAccelerationTaskInfo';
import { IDatasourceActions } from '../../../../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../../../../ts/ServerApi/types/IWorkbookActions';
import { Messages } from '../../../../../codegen/Localize';

export const DeleteDataAccelerationTaskEntityAction: IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksDelete,
  translateName: Messages.delete_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: deleteDataAccelerationTask
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  return currentUserIsAdmin(state);
}
